<template>
  <div>
    <div>
      <div class="d-flex justify-content-between align-items-center">
        <div class="element-title">
          {{ $t('settings.permissions.groups-roles.roles.title') }}
        </div>
        <!-- ADD A ROLE -->
        <el-button
          class="mb-2"
          type="primary"
          size="mini"
          :disabled="roles === null"
          @click="triggerAddRole"
        >
          {{ $t('settings.permissions.groups-roles.roles.create-role-button') }}
        </el-button>
      </div>
      <div class="element-description">
        {{ $t('settings.permissions.groups-roles.roles.description') }}
      </div>
      <!-- ROLE TABLE-->
      <div
        class="row user-groups-table"
        v-if="success"
        v-loading="rolesIsLoading"
      >
        <div class="col-12 mt-4">
          <roles-table
            :company-roles="roles"
            @edit-role="triggerEditRole"
            @delete-role="deleteRole"
          />
        </div>
      </div>
      <div
        v-else
        class="d-flex justify-content-center mt-2"
        v-loading="rolesIsLoading"
      >
        <el-button size="small" type="primary" @click="getRoles">
          {{ $t('settings.reload') }}
        </el-button>
      </div>
    </div>
    <roles-drawer
      v-if="drawers.roleDrawer"
      :show="drawers.roleDrawer"
      :role="focusedRole"
      @cancel="closeRoleDrawer"
      @save="updateOrCreateRole"
      @update-focused-role="updateFocusedRole"
    />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import RolesTable from './RolesSettings/RolesTable';
import RolesDrawer from './RolesSettings/RolesDrawer';

export default {
  name: 'roles-settings-main',
  components: {
    RolesTable,
    RolesDrawer,
  },
  props: {
    generalSuccess: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      drawers: {
        roleDrawer: false,
      },
      focusedRole: null,
      step: 1,
      localSuccess: true,
    };
  },
  computed: {
    success() {
      return this.generalSuccess && this.localSuccess;
    },
    ...mapGetters('adminModule', ['roles', 'rolesIsLoading']),
  },
  methods: {
    async getRoles() {
      this.localSuccess = await this.getCustomRoles();
    },
    triggerAddRole() {
      this.focusedRole = {
        name: '',
        customRolePermissions: [{ rolePermission: 'READ_CONTENT', scope: {} }],
      };
      this.drawers.roleDrawer = true;
    },
    triggerEditRole(roleId) {
      this.focusedRole = { ...this.roles.find((o) => o.id === roleId) };
      this.drawers.roleDrawer = true;
    },
    updateFocusedRole({ key, value }) {
      this.focusedRole[key] = value;
      this.focusedRole.hasBeenEdited = true;
    },
    closeRoleDrawer() {
      this.drawers.roleDrawer = false;
      this.focusedRole = null;
    },
    async updateOrCreateRole() {
      const { id, name, customRolePermissions, hasBeenEdited } =
        this.focusedRole;
      if (!hasBeenEdited) return this.closeRoleDrawer();

      this.closeRoleDrawer();
      if (id) {
        this.localSuccess = await this.updateCustomRole({
          id: id,
          customRole: { name, customRolePermissions },
        });
      } else {
        this.localSuccess = await this.createCustomRole({
          name,
          customRolePermissions,
        });
      }
    },
    async deleteRole(payload) {
      this.localSuccess = await this.deleteCustomRole(payload);
    },
    ...mapActions('adminModule', [
      'getCustomRoles',
      'updateCustomRole',
      'createCustomRole',
      'deleteCustomRole',
    ]),
  },
};
</script>
<style lang="scss" scoped>
.element-title {
  font-size: 16px;
  line-height: 19px;
  font-weight: 500;
  font-weight: bold;
}

.element-description {
  font-size: 12px;
  color: $grey-7-mayday;
}
/* Drawer style */
.hosting-container {
  padding-left: 20px;
}

.role-drawer {
  :deep() span:focus {
    outline: none;
  }
}
.role-drawer {
  :deep() .el-drawer__close-btn:focus {
    outline: none;
  }
}

.role-drawer {
  :deep() .el-drawer__header {
    text-transform: uppercase;
    font-weight: 600;
    letter-spacing: 1px;
  }
}

.subtitle {
  text-transform: uppercase;
  color: #adb5bd;
}

.role-feature-icon {
  color: #32325d;
  max-width: 14px;
}

.small-icon {
  max-width: 20px;
}

.cant-do-feature {
  color: #ced4da;
}

.can-do-feature {
  color: #828282;
}
/* End drawer style */

.sub-item {
  color: #adb5bd;
}

.user-groups-table {
  :deep() .card {
    border: none;
  }
}

.small-icon-hoverable {
  width: 15px;
  height: 15px;
  padding: 2px;
  color: #8898aa;
  margin-left: 10px;
}
.small-icon-hoverable:hover {
  border-radius: 2px;
  background-color: #e9ecef;
  cursor: pointer;
}

.settings-card-header-description {
  color: #8898aa;
  font-size: 80%;
}

.subtitle {
  text-transform: uppercase;
  color: #adb5bd;
}

.right-divider {
  border-top: 1px solid#e9ecef;
}

.send-invitation {
  max-height: 50vh;
  overflow: auto;
  overflow-x: hidden;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}

.vertical-line {
  border-left: 1px solid lightgrey;
}

.plus-icon {
  padding: 5px;
  border: 1px solid $blue-mayday;
  border-radius: 40px;
  padding-left: 10px;
  padding-right: 10px;
}

.plus-icon:hover {
  background-color: rgba($blue-mayday, 0.4);
  color: white;
  cursor: pointer;
}
.plus-icon {
  padding: 5px;
  border: 1px solid $blue-mayday;
  border-radius: 40px;
  padding-left: 10px;
  padding-right: 10px;
}

.plus-icon:hover {
  background-color: rgba($blue-mayday, 0.4);
  color: white;
  cursor: pointer;
}

.main-container {
  margin-top: 40px;
  margin-bottom: 40px;
}

.menubar__input {
  margin: 0px;
}

.menububble__form {
  display: inline-block;
}

.menubar__button {
  background-color: Transparent;
  outline: none;
  border: none;
  border-radius: 5px;
}

.menubar__button:hover {
  background-color: #dee2e6;
}

.empty-placeholder {
  color: #ced4da;
}

.options_selection {
  max-width: 20px;
  cursor: pointer;
}

.center-element {
  justify-content: center;
  vertical-align: middle;
  display: flex;
}

.dropdown {
  padding: 0px;
  border-width: 0px;
  box-shadow: none;
  background-color: transparent;
  margin-right: 0px;
  margin: 5px;
}

.dropdown:hover {
  background-color: white;
}

.dropdown-item span {
  margin-left: 10px;
}

.dropdown-item:hover {
  cursor: pointer;
}

.col-1 {
  width: 400px;
}
th {
  font-weight: bold;
}

tr {
  align-items: baseline;
}

td {
  color: #525f7f;
  font-size: 13px !important;
}

.table-header {
  background-color: white;
  align-items: baseline;
  height: 40px;
  text-transform: uppercase;
  font-size: 0.65rem;
}

.header-col {
  color: #8898aa;
}

.no-margin {
  margin-left: 0px !important;
  margin-right: 0px !important;
  margin-top: 10px;
  margin-top: 0px;
  margin-bottom: 0px;
}
</style>
